import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const results = [{
  name: 'Marcus T.',
  location: 'Atlanta, GA',
  quote: 'Went from 512 to 761 in 34 days — got approved for a $25K Chase card the same week.',
  points: '+249 pts'
}, {
  name: 'Diana L.',
  location: 'Phoenix, AZ',
  quote: 'Two bankruptcies removed in under 30 days. I cried when I saw my new score.',
  points: '+198 pts'
}, {
  name: 'James W.',
  location: 'Dallas, TX',
  quote: 'Secured $40K in business credit at 0% APR. This system paid for itself 1000x over.',
  points: '+187 pts'
}];
function FicoGauge() {
  return <svg viewBox="0 0 120 80" className="w-full max-w-[140px] mx-auto" data-id="element-184">
      {/* Background arc */}
      <path d="M 15 70 A 50 50 0 0 1 105 70" fill="none" stroke="#1a1a24" strokeWidth="8" strokeLinecap="round" data-id="element-185" />
      {/* Cyan progress arc */}
      <path d="M 15 70 A 50 50 0 0 1 105 70" fill="none" stroke="#00F2FF" strokeWidth="8" strokeLinecap="round" strokeDasharray="142" strokeDashoffset="18" style={{
      filter: 'drop-shadow(0 0 6px rgba(0, 242, 255, 0.5))'
    }} data-id="element-186" />
      {/* Score text */}
      <text x="60" y="55" textAnchor="middle" fill="#00F2FF" fontSize="22" fontWeight="bold" fontFamily="'Space Grotesk', sans-serif" data-id="element-187">
        750+
      </text>
      <text x="60" y="70" textAnchor="middle" fill="#666" fontSize="8" fontFamily="'Inter', sans-serif" data-id="element-188">
        FICO SCORE
      </text>
    </svg>;
}
export function ResultsGridSection() {
  return <section className="py-24 px-4" style={{
    backgroundColor: '#080808'
  }} data-id="element-189">
      <div className="max-w-6xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-191">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3" style={{
          fontFamily: "'Space Grotesk', sans-serif"
        }} data-id="element-192">
            REAL{' '}
            <span style={{
            color: '#00F2FF'
          }} data-id="element-193">
              2026
            </span>{' '}
            RESULTS
          </h2>
          <p className="text-gray-500 text-lg" data-id="element-194">
            Verified members who used the Credit Architecture system.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-195">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-[#0e0e16] border border-white/10 rounded-2xl p-6 text-center hover:border-[#00F2FF]/30 transition-colors" data-id="element-196">
              {/* FICO Gauge */}
              <div className="mb-5" data-id="element-197">
                <FicoGauge data-id="element-198" />
              </div>

              {/* Result badge */}
              <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full mb-4" style={{
            backgroundColor: 'rgba(0, 242, 255, 0.1)',
            border: '1px solid rgba(0, 242, 255, 0.2)'
          }} data-id="element-199">
                <CheckCircle2 className="w-4 h-4" style={{
              color: '#00F2FF'
            }} data-id="element-200" />
                <span className="text-sm font-bold" style={{
              color: '#00F2FF'
            }} data-id="element-201">
                  {result.points}
                </span>
              </div>

              {/* Quote */}
              <p className="text-gray-300 text-base leading-relaxed mb-5 italic" data-id="element-202">
                "{result.quote}"
              </p>

              {/* Attribution */}
              <div className="border-t border-white/5 pt-4" data-id="element-203">
                <p className="text-white font-semibold" data-id="element-204">{result.name}</p>
                <p className="text-gray-500 text-sm" data-id="element-205">{result.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}